// extracted by mini-css-extract-plugin
export default {"dataCollectorList":"ReplaceSupervisorDialog_dataCollectorList__fOOgJ"};